import React from "react";
import { Pie, Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
} from "chart.js";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement
);

const DashboardCharts = () => {
  const pieData = {
    labels: ["Received", "Pending"],
    datasets: [
      {
        data: [994176, 9883024],
        backgroundColor: ["#4CAF50", "#F44336"],
        borderWidth: 2,
        hoverOffset: 8,
      },
    ],
  };

  const barData = {
    labels: ["Jan", "Feb", "Mar", "May", "Oct", "Nov"],
    datasets: [
      {
        label: "Monthly Income",
        data: [15000, 363157, 423950, 6500, 1500, 2000],
        backgroundColor: "#2196F3",
        borderRadius: 8,
        barThickness: 22,
      },
    ],
  };

  const lineData = {
    labels: ["Jul", "Oct", "Dec", "Mar", "Apr"],
    datasets: [
      {
        label: "Weekly Trend",
        data: [15000, 2250, 1500, 3000, 2000],
        borderColor: "#FF9800",
        backgroundColor: "rgba(255, 152, 0, 0.3)",
        pointBackgroundColor: "#FF5722",
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          color: "#333",
          padding: 15,
          boxWidth: 18,
          font: { size: 13 },
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.parsed;
            return `₹ ${value.toLocaleString("en-IN")}`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#555", font: { size: 12 } },
      },
      y: {
        grid: {
          color: "#e0e0e0",
          borderDash: [3, 3],
        },
        ticks: {
          color: "#555",
          font: { size: 12 },
          callback: function (value) {
            return `₹${value / 1000}K`;
          },
        },
      },
    },
  };

  return (
    <div className="container-fluid my-5 px-4">
      <div className="row g-4">
        {/* Pie Chart Section */}
        <div className="col-md-6">
          <div className="card shadow-sm border border-success-subtle h-100">
            <div className="card-body text-center">
              <h4 className="mb-3 text-uppercase text-secondary">Total Fee Collected</h4>
              <h2 className="fw-bold text-dark mb-3">₹ 1,08,77,200</h2>
              <div className="mb-4 d-flex justify-content-center gap-4">
                <span className="fw-semibold text-success">Received: ₹9,94,176</span>
                <span className="fw-semibold text-danger">Pending: ₹98,83,024</span>
              </div>
              <div style={{ height: "320px" }}>
                <Pie data={pieData} options={chartOptions} />
              </div>
            </div>
          </div>
        </div>

        {/* Bar + Line Chart Section */}
        <div className="col-md-6">
          <div className="card shadow-sm border border-info-subtle h-100">
            <div className="card-body">
              <h5 className="mb-4 text-secondary">Monthly Income</h5>
              <div className="mb-4" style={{ height: "200px" }}>
                <Bar data={barData} options={chartOptions} />
              </div>
              <h5 className="mb-3 text-secondary">Weekly Fee Trends</h5>
              <div style={{ height: "180px" }}>
                <Line data={lineData} options={chartOptions} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCharts;
